module.exports = __webpack_public_path__ + "img/icon_uk.18a4b8f0.png";